import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-330cdc7f")
const _hoisted_1 = { class: "pinned-assets" }
const _hoisted_2 = { class: "pinned-assets-inner" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "No assets added!", -1)
const _hoisted_5 = [
  _hoisted_4
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AssetCard = _resolveComponent("AssetCard")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar")!
  const _component_PinnedAssetModal = _resolveComponent("PinnedAssetModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_perfect_scrollbar, null, {
        default: _withCtx(() => [
          _createVNode(_component_draggable, {
            class: "pinned-assets-content list-group",
            modelValue: _ctx.getPinnedAssets,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.getPinnedAssets = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPinnedAssets, (asset, i) => {
                return (_openBlock(), _createBlock(_component_AssetCard, {
                  key: i,
                  asset: asset,
                  onOnRemove: _cache[0] || (_cache[0] = (a) => (_ctx.pinnedAssetData = a))
                }, null, 8, ["asset"]))
              }), 128)),
              (_ctx.getPinnedAssets.length === 0 && !_ctx.isPinnedAssetsLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_PinnedAssetModal, {
      "pinned-asset-data": _ctx.pinnedAssetData,
      onOnClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pinnedAssetData = null))
    }, null, 8, ["pinned-asset-data"])
  ]))
}